<template>
    <ckeditor 
        :editor="editor" 
        v-model="hidden_value" 
        :config="conf"
        @input="onEditorInput"
    />
</template>

<script>
    import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic';
    import { ImageToolbar, Image, ImageCaption, ImageStyle, ImageUpload, PictureEditing, ImageInsert, ImageInsertUI, ImageInsertViaUrl } from '@ckeditor/ckeditor5-image';
    import { Essentials } from '@ckeditor/ckeditor5-essentials';
    import { Bold, Italic, Underline } from '@ckeditor/ckeditor5-basic-styles';
    import { Link } from '@ckeditor/ckeditor5-link';
    import { Paragraph } from '@ckeditor/ckeditor5-paragraph';
    import { SimpleUploadAdapter } from '@ckeditor/ckeditor5-upload';
    import { Heading } from '@ckeditor/ckeditor5-heading';
    import { Table, TableToolbar } from '@ckeditor/ckeditor5-table';
    import { BlockQuote } from '@ckeditor/ckeditor5-block-quote';
    import { List } from '@ckeditor/ckeditor5-list';
    import { TextTransformation } from '@ckeditor/ckeditor5-typing';
    import { Indent } from '@ckeditor/ckeditor5-indent';
    import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage';

    export default {
        props: ['value'],
        data() {
            return {
                editor: ClassicEditor,
                conf: {
                    plugins: [
                        Essentials,
                        Bold,
                        Italic,
                        Underline,
                        Image,
                        ImageInsert,
                        ImageToolbar,
                        ImageCaption,
                        ImageStyle,
                        ImageUpload,
                        PictureEditing,
                        Link,
                        Paragraph,
                        SimpleUploadAdapter,
                        Heading,
                        Table,
                        TableToolbar,
                        BlockQuote,
                        List,
                        Indent,
                        TextTransformation,
                        ImageInsertUI,
                        ImageInsertViaUrl,
                        LinkImage
                    ],
                    toolbar: {
                        items: [
                            'undo', 'redo',
                            '|', 'heading',
                            '|', 'bold', 'italic', 'underline',
                            '|', 'link', 'insertImage', 'insertTable', 'blockQuote',
                            '|', 'bulletedList', 'numberedList', 'outdent', 'indent'
                        ]
                    },
                    image: {
                        toolbar: [
                            'imageTextAlternative',
                            'linkImage'
                        ]
                    },
                    simpleUpload: {
                        uploadUrl: process.env.VUE_APP_API_BASE + '/ckeditor/uploadImage?api_key=' + localStorage.getItem('token'),
                        types: ["jpeg", "png", "jpg"],
                        withCredentials: false,
                        headers: {
                            'Authorization': localStorage.getItem('token'),
                            'Hash-Teatro': localStorage.getItem('hash_teatro')
                        }
                    },
                },
                hidden_value: this.value || ''
            }
        },
        methods: {
            onEditorInput(e) {
                this.$emit('input', e)
            }
        }
    }
</script>

<style>
    .ck-editor {
        min-height: 180px;
    }
    .ck-editor__main {
        min-height: 180px;
    }
    .ck-editor__editable {
        min-height: 180px;
    }
</style>
